import Avatar from '@material-ui/core/Avatar';
import Grid from '@material-ui/core/Grid';
import { makeStyles } from '@material-ui/core/styles';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import VideoTile from '../video-components/VideoTile';
import PlaceHolderTile from '../video-components/PlaceHolderTile';
import { useSelector } from 'react-redux';

const useStyles = makeStyles(() => ({
  chip: {
    position: 'absolute',
    backgroundColor: '#FFFFFF',
    fontWeight: '600',
    zIndex: '2',
    color: 'black',
    '&:hover': {
      background: '#00C4FF',
      color: 'white',
      cursor: 'pointer',
    },
    '&:active': {
      background: 'rgba(0,0,0,.5)',
    },
  },
  grid: {
    position: 'relative',
  },
  icon: {
    marginLeft: '8px',
  },
  leftIcon: {
    left: '10px',
    top: '45%',
  },
  rightIcon: {
    right: '13px',
    top: '45%',
  },
}));

PaginatedView.propTypes = {
  videos: PropTypes.object,
  pageLength: PropTypes.number,
  selectSpeaker: PropTypes.func,
};

PaginatedView.defaultProps = {
  pageLength: 3,
};

export default function PaginatedView({ videos, pageLength, selectSpeaker }) {
  const classes = useStyles();
  const [currentPage, setCurrentPage] = useState(0);
  const [pages, setPages] = useState([]);
  const { tileMap } = useSelector(({ video }) => ({
    tileMap: video.tileMap,
  }));

  useEffect(() => {
    const newPages = [];
    Object.keys(videos).forEach((video, index) => {
      if (newPages[Math.floor(index / pageLength)]) {
        newPages[Math.floor(index / pageLength)].push({ ...videos[video], id: video });
      } else {
        newPages[Math.floor(index / pageLength)] = [];
        newPages[Math.floor(index / pageLength)].push({ ...videos[video], id: video });
      }
    });
    setPages(newPages);
  }, [videos, pageLength]);

  const previousPage = () => {
    if (currentPage > 0) {
      setCurrentPage(currentPage - 1);
    }
  };

  const nextPage = () => {
    if (currentPage < pages.length - 1) {
      setCurrentPage(currentPage + 1);
    }
  };

  const fillTiles = pages[currentPage] ? 3 - pages[currentPage].length : 3;

  return (
    <Grid container justify="center" spacing={0} className={classes.grid}>
      {currentPage !== 0 && (
        <Avatar className={`${classes.chip} ${classes.leftIcon}`} onClick={previousPage}>
          <ArrowBackIosIcon className={classes.icon} />
        </Avatar>
      )}
      {pages &&
        pages[currentPage] &&
        pages[currentPage].map((video) => {
          return (
            <Grid item xs={4} key={video.id} className={classes.grid}>
              <VideoTile
                videoTileId={tileMap[video.id]}
                thisAttendeeId={video.id}
                selectSpeaker={selectSpeaker}
              />
            </Grid>
          );
        })}
      {[...Array(fillTiles).keys()].map((index) => {
        return (
          <Grid item xs={4} key={index} className={classes.grid}>
            <PlaceHolderTile />
          </Grid>
        );
      })}
      {currentPage < pages.length - 1 && (
        <Avatar className={`${classes.chip} ${classes.rightIcon}`} onClick={nextPage}>
          <ArrowForwardIosIcon className={classes.icon} />
        </Avatar>
      )}
    </Grid>
  );
}
